export default process.env.ENVCFG === 'production'
  ? [{
    path: 'sentryTestSuite',
    getComponent(nextState, callback) {
      import(/* webpackChunkName: "sentryTest" */ './containers/SentryTestSuite')
        .then(component => callback(null, component.default));
    },
    childRoutes: [
      {
        path: ':somePath', // Required for testing same errors on multiple routes
        getComponent(location, callback) {
          import(/* webpackChunkName: "sentryTest" */ './containers/SentryTestSuite')
            .then(component => callback(null, component.default));
        },
      },
    ],
  }]
  : [];
